<template>
  <div class="customer-editor">

      <el-form :model="form" :rules="rules" ref="form" v-loading="loading" :label-width="width">

        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="date" label="客户名称" width="180"></el-table-column>
          <el-table-column prop="name" label="房产" width="180"></el-table-column>
          <el-table-column prop="address" label="计费周期"></el-table-column>
          <el-table-column prop="address" label="欠费金额"></el-table-column>
          <el-table-column prop="address" label="是否发函"></el-table-column>
          <el-table-column prop="address" label="发函时间"></el-table-column>
          <el-table-column prop="address" label="签收状态"></el-table-column>
          <el-table-column prop="address" label="签收人"></el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination background layout="prev, pager, next" :total="0"></el-pagination>
        </div>

      </el-form>

  </div>
</template>

<script>

  import Common from './common.js'

  export default {
    name: "message-management-editor",
    props: {
      value: {
        type: Boolean,
        default() {
          return false
        }
      },
      id: {
        type: [Number, String],
        default() {
          return 0
        }
      },
      width: {
        type: String,
        default() {
          return '110px'
        }
      },
      is_edit:{
        type: Boolean,
        default() {
          return true
        }
      }
    },
    data(){
      return{
        visable: this.value,
        loading: false,
        form: {},
        rules: {},
        tableData: [],
      }
    },
    mounted() {
      console.log('message-management mounted')
    },
    watch: {
      value(val) {
      	this.visable = val
      },
      visable(val) {
        this.$emit('input', val)
      },
      id(val) {
        if(this.visable) {

        }
      },
    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped="scoped">

  @import "./common.scss";



  .el-checkbox {
    margin-right: 10px;

    .el-checkbox__label {
      margin-left: 5px;
    }
  }

  .el-radio {
    margin-right: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/message-management-editor.vue